<template>
	<v-card
		v-can="'invoice.create'"
	>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$autoFix"
				start
			/>
			<translate>Actions</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-btn
						color="primary"
						variant="flat"
						:disabled="loading"
						:loading="loading"
						@click="submit"
					>
						<translate>Create deductible invoice</translate>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import axios from 'axios';
import {
	debounce,
} from 'lodash';
import {
	displayError, inform,
} from 'laravel-front-library';
export default {
	name: 'ClaimActionsCard',

	props: {
		claimId: {
			type: String,
			required: true
		}
	},

	data () {
		return {
			loading: false
		};
	},

	methods: {
		/**
		 * Submit to create deductible invoice by claim id
		 */
		submit () {
			this.loading = true;
			const formData = new FormData();

			formData.append('claim_id', this.claimId);
			axios.post('/bo/claims/doCreateDeductibleInvoice', formData)
				.then(({
					data
				}) => {
					inform('Deductible invoice created.');
					debounce(() => {
						window.location.href = `/bo/invoices/view?id=${data}`;
					}, 1000)();
				})
				.catch((error) => {
					displayError(error.response.data);
					window.captureException(error);
				}).finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

